// Shape returned by GET /api/clinics/:id/deletion-impact (see apps/admin-api services/clinic.ts).
export interface ClinicDeletionAccount {
  user_id: number
  account: string
  user_name: string
}
export interface ClinicDeletionBlockedAccount extends ClinicDeletionAccount {
  reason: string
}
export interface ClinicDeletionImpact {
  clinic: { clinic_id: number; clinic_name: string }
  canDelete: boolean
  accountsToDelete: ClinicDeletionAccount[]
  blockedAccounts: ClinicDeletionBlockedAccount[]
  relatedCounts: {
    clinicUsers: number
    roles: number
    doctors: number
    examinationRooms: number
    queueMachines: number
    appointments: number
    clinicModules: number
    broadcastDevicesUnlinked: number
  }
}

// The confirm button is enabled only when nothing blocks the delete AND the admin has
// re-typed the exact clinic name — an irreversible cascade needs a deliberate confirmation.
export function canConfirmClinicDeletion(
  impact: ClinicDeletionImpact | null,
  confirmInput: string,
): boolean {
  if (!impact || !impact.canDelete) return false
  return confirmInput.trim() === impact.clinic.clinic_name
}
